import { render, staticRenderFns } from "./onboarding-view.vue?vue&type=template&id=c52b5a2e&scoped=true"
import script from "./onboarding-view.vue?vue&type=script&lang=js"
export * from "./onboarding-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b5a2e",
  null
  
)

export default component.exports